<template>
	<!-- <Row :gutter="32">
		<Col class="demo-tabs-style1" style="background: #e3e8ee;padding:16px;">
		<Tabs type="card" :value="subName">
			<TabPane label="咨询分类" name="咨询分类">
				<div class="box2">
					<div class="title">联系我们</div>
					<div class="content" v-html="info.content"></div>
				</div>
			</TabPane>
			<TabPane label="意见反馈" name="意见反馈">
				<item6></item6>
			</TabPane>
		</Tabs>
		</Col>
	</Row> -->
	<div class="aa">
		<div class="box2">
			<div class="title">联系我们</div>
			<div class="content" v-html="info.content"></div>
		</div>
		<item6></item6>
	</div>
</template>

<script>
	import item6 from './item6.vue'
	import {
		getSingleArticle
	} from '@/api/home/guild'
	export default {
		components: {
			item6
		},
		data() {
			return {
				info: {},
				value: '',
				subName: ''
			}

		},
		mounted() {
			this.getSingleArticle()
		},
		methods: {
			getSingleArticle() {
				getSingleArticle({
					catid: 3,
				}).then(res => {
					if (res.code == 200 || res.code == 0) {
						this.info = res.result;
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.aa{
		box-shadow: 0px 4px 10px 0px #164EB9;
		padding-bottom: 50px;
		margin: 30px 100px;
		padding: 20px;
		border-radius: 10px;
	}
	.box2 {
		color: #011243;
		font-size: 14px;
		min-width: 600px;

		.title {
			font-size: 25px;
			text-align: center;
			margin-bottom: 10px;
			margin-top: 20px;
		}
	}

	// .big_box{
	// 	.ivu-tabs-card > .ivu-tabs-content > .ivu-tabs-tabpane{
	// 		background-color: #fff;
	// 		border: 1px solid #2d8cf0;
	// 		border-top: none;
	// 	}
	/deep/.ivu-tabs-bar {
		margin: 0;
	}

	// }
	.demo-tabs-style1>.ivu-tabs-card>.ivu-tabs-content {
		height: 120px;
		margin-top: -16px;
	}

	.demo-tabs-style1>.ivu-tabs-card>.ivu-tabs-content>.ivu-tabs-tabpane {
		background: #fff;
		padding: 16px;
	}

	.demo-tabs-style1>.ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab {
		border-color: transparent;
	}

	.demo-tabs-style1>.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active {
		border-color: #fff;
	}
</style>
